export default "__VITE_ASSET__4f6c705f__"